import React from 'react';
import { Box, alpha, CardHeader, CardContent } from '@mui/material';
import { COLORS, ModernCard } from '../../../../pages/Organisation/DailyUpdates/utils';

const RegistrarSkeleton = () => {
	return (
		<Box
			sx={{
				p: 3,
				maxWidth: '1400px',
				margin: '0 auto',
				backgroundColor: alpha(COLORS.neutral, 0.5),
				borderRadius: '24px'
			}}
		>
			{/* Stats Overview Cards Skeleton */}
			<Box sx={{ display: 'flex', gap: 3, mb: 4 }}>
				{/* Existing Students Card Skeleton */}
				<ModernCard sx={{ flex: 1 }}>
					<CardHeader>
						<Box sx={{ width: '60%', height: '24px', bgcolor: COLORS.neutralDark, borderRadius: 1 }} />
						<Box
							sx={{ width: '40%', height: '16px', bgcolor: COLORS.neutralDark, borderRadius: 1, mt: 1 }}
						/>
					</CardHeader>
					<CardContent sx={{ p: 3 }}>
						<Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
							{[1, 2, 3].map((index) => (
								<Box key={index}>
									<Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
										<Box
											sx={{
												width: '30%',
												height: '16px',
												bgcolor: COLORS.neutralDark,
												borderRadius: 1
											}}
										/>
										<Box
											sx={{
												width: '15%',
												height: '24px',
												bgcolor: COLORS.neutralDark,
												borderRadius: 1
											}}
										/>
									</Box>
									<Box
										sx={{
											width: '100%',
											height: '8px',
											bgcolor: COLORS.neutralDark,
											borderRadius: 1
										}}
									/>
								</Box>
							))}
						</Box>
					</CardContent>
				</ModernCard>

				{/* New Students Card Skeleton */}
				<ModernCard sx={{ flex: 1 }}>
					<CardHeader>
						<Box sx={{ width: '60%', height: '24px', bgcolor: COLORS.neutralDark, borderRadius: 1 }} />
						<Box
							sx={{ width: '40%', height: '16px', bgcolor: COLORS.neutralDark, borderRadius: 1, mt: 1 }}
						/>
					</CardHeader>
					<CardContent sx={{ p: 3 }}>
						<Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
							{[1, 2, 3].map((index) => (
								<Box key={index}>
									<Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
										<Box
											sx={{
												width: '30%',
												height: '16px',
												bgcolor: COLORS.neutralDark,
												borderRadius: 1
											}}
										/>
										<Box
											sx={{
												width: '15%',
												height: '24px',
												bgcolor: COLORS.neutralDark,
												borderRadius: 1
											}}
										/>
									</Box>
									<Box
										sx={{
											width: '100%',
											height: '8px',
											bgcolor: COLORS.neutralDark,
											borderRadius: 1
										}}
									/>
								</Box>
							))}
						</Box>
					</CardContent>
				</ModernCard>
			</Box>
		</Box>
	);
};

export default RegistrarSkeleton;
